<template>
	<div>
		<topTab ref="topTab" :tab-data="tabData" @tab-change="changePages">
			<el-form :inline="true" :model="formInline" class="user-search">
				<el-form-item label="所属门店：">
					<el-select v-model="formInline.storeKeyId" placeholder="请选择门店" filterable size="small" @change="inputChange">
						<el-option v-for="item in storeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="月份">
					<el-date-picker v-model="dateStr" type="month" size="small" :editable="false" :clearable="false" placeholder="请选择月份" format="yyyy年MM月" @change="dateChange"></el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-button v-if="$checkBtnPermission('/storeCheck/index', 'viewPage')" size="small" type="primary" class="el-icon-search" @click="inputChange()">搜索</el-button>
				</el-form-item>
				<el-form-item>
					<el-button v-if="$checkBtnPermission('/storeCheck/index', 'export')" size="small" type="warning" class="el-icon-s-promotion" @click="handleExportClick()" :loading="exportLoading">导出</el-button>
				</el-form-item>
				<el-form-item>
					<el-button v-if="$checkBtnPermission('/storeCheck/index', 'realQty')" size="small" type="primary" class="el-icon-edit" @click="handleRealHouseClick()">真实库存</el-button>
				</el-form-item>
			</el-form>
			<STable :columns="columnsData" :data="listData" :loading="loading" border stripe @get-data="getListData">
				<template #monthStr>
					<el-table-column label="年月" width="100" align="center">
						<template #default="scope">{{ scope.row.year }}年{{ scope.row.month }}月</template>
					</el-table-column>
				</template>
				<template #chae>
					<el-table-column label="差额" width="120" align="center">
						<template #default="scope">
							<span :class="scope.row.realQuantity - scope.row.quantity != 0 ? 'danger' : ''">
								{{ scope.row.realQuantity - scope.row.quantity }}
							</span>
						</template>
					</el-table-column>
				</template>
			</STable>
			<!-- 分页组件 -->
			<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
		</topTab>
		<realQty ref="realQty"></realQty>
	<exportBlockDialog :visible.sync="exportBlockVisible" :title="exportBlockTitle" :blocks="exportBlockData" />
	</div>
</template>

<script>
import { GetMonthStoreProductList, ExportMonthStoreProduct } from "@/api/productApi.js";
import { GetOrgInfoListByConfig } from "@/api/organizationalApi.js";
import { exportWithLoading } from "@/api/exportFile";
import exportBlockDialog from "@/components/exportBlockDialog.vue";
import realQty from "./realQty.vue";
export default {
	data() {
		return {
			activeTab: "1",
			tabData: [
				{
					key: "1",
					value: "门店库存盘点"
				}
			],
			pageShow: true,
			loading: false, // 显示加载
			exportLoading: false, // 导出按钮 loading
			listData: [],
			selectionList: [],
			// 分页参数
			pageparm: {
				pageIndex: 1,
				pageSize: 10,
				total: 0
			},
			formInline: {
				pageIndex: 1,
				pageSize: 10,
				storeKeyId: "",
				year: parseInt(new Date().getFullYear()),
				month: parseInt(new Date().getMonth() + 1)
			},
			storeList: [],
			columnsData: [], //显示列
			listColumns: [
				{
					prop: "rowNumber",
					label: "序号",
					align: "center",
					width: "80",
					isKeep: true
				},
				{
					slot: "monthStr",
					label: "月份",
					minWidth: "100",
					align: "center"
				},
				{
					prop: "storeName",
					label: "门店名称",
					isKeep: true,
					width: "120",
					align: "center"
				},
				{
					slot: "productInfo.code",
					label: "商品编码",
					isKeep: true,
					minWidth: "170",
					align: "center",
				},
				{
					prop: "productInfo.typeName",
					label: "类型",
					width: "140",
					align: "center"
				},
				{
					prop: "productInfo.productName",
					label: "系列",
					width: "180",
					align: "center"
				},
				{
					prop: "productInfo.specification",
					label: "商品名称",
					minWidth: "150",
					align: "center"
				},
				{
					prop: "productInfo.unit",
					label: "单位",
					width: "120",
					align: "center"
				},
				{
					prop: "price",
					label: "价格(元)",
					width: "120",
					align: "center",
					isMoney: true,
					moneyType: "normal"
				},
				{
					prop: "quantity",
					label: "库存数量",
					width: "120",
					align: "center"
				},
				{
					prop: "realQuantity",
					label: "真实数量",
					width: "120",
					align: "center"
				},
				{
					slot: "chae",
					label: "差额",
					width: "120",
					align: "center"
				},
				{
					prop: "creator",
					label: "盘点人",
					width: "120",
					align: "center"
				},
				{
					prop: "createTime",
					label: "盘点时间",
					width: "170",
					align: "center"
				}
			],
			dateStr: "",
			exportBlockVisible: false,
			exportBlockTitle: "",
			exportBlockData: []
		};
	},
	// 注册组件
	components: {
		realQty,
		exportBlockDialog
	},
	created() {
		// 初始列
		this.getCheckBox(this.listColumns.map((item) => item.label));
		this.GetOrgInfoListByConfig();
		this.dateStr = new Date().getFullYear() + "-" + (new Date().getMonth() + 1);
	},
	computed: {},
	methods: {
		// 获取筛选框
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},
		changePages() {},
		// 获取所属门店
		GetOrgInfoListByConfig() {
			const paramer = {
				key: 1
			};
			GetOrgInfoListByConfig(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.storeList = [];
						res.data.forEach((item) => {
							this.storeList.push({
								keyId: item.keyId,
								value: item.name + "【" + item.remark2 + "】"
							});
						});
						this.formInline.storeKeyId = this.storeList[0].keyId;
						this.getListData();
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取门店信息失败!");
				});
		},
		// 获取列表
		getListData() {
			this.loading = true;
			GetMonthStoreProductList(this.formInline)
				.then((res) => {
					if (res.code == 1) {
						this.loading = false;
						this.listData = res.data;
						this.pageparm.total = res.totalNumber;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		inputChange(val) {
			this.search();
		},
		// 分页插件事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		},
		// 搜索事件
		search() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		},
		// 月份选择事件
		dateChange() {
			this.formInline.year = this.dateStr.getFullYear();
			this.formInline.month = this.dateStr.getMonth() + 1;
			this.getListData();
		},
		// 导出事件
		handleExportClick() {
			this.loading = true;
			if (!this.formInline.storeKeyId) {
				this.$message.error("请选择门店！");
				return;
			}
			exportWithLoading(this, "exportLoading", () => ExportMonthStoreProduct(this.formInline), "导出失败!").then(() => {
				this.loading = false;
			});
		},
		// 真实库存事件
		handleRealHouseClick() {
			var info = {
				storeKeyId: this.formInline.storeKeyId,
				month: this.formInline.month,
				year: this.formInline.year
			};
			if (!info.storeKeyId) {
				this.$message.error("请选择门店！");
				return;
			}
			if (!info.month) {
				this.$message.error("请选择月份！");
				return;
			}
			if (!info.year) {
				this.$message.error("请选择年份！");
				return;
			}
			this.$refs.realQty.showAuditSubscriptionDetail(info);
		}
	}
};
</script>

<style scoped>
.danger {
	color: white;
	display: inline-block;
	border-radius: 5px;
	background-color: red;
	width: 100%;
	height: 100%;
}
</style>
